import { StorageKey } from "./storage";

export enum FeatureToggle {
    HotkeysEnabled = "hotkeysEnabled",
    AxisSphereVisible = "axisSphereVisible",
    MiniMapVisible = "miniMapVisible",
    JoysticksVisible = "joysticksVisible",
    UpdateHomeView = "updateHomeView",
    SpaceMouseEnabled = "spaceMouseEnabled",
    ExperimentalEngineEnabled = "experimentalEngineEnabled",
}

export const FEATURE_TOGGLE_CONFIG: Record<FeatureToggle, { defaultValue: boolean; storageKey?: StorageKey }> = {
    [FeatureToggle.HotkeysEnabled]: { defaultValue: true },
    [FeatureToggle.AxisSphereVisible]: { defaultValue: true, storageKey: StorageKey.NavigationCube },
    [FeatureToggle.MiniMapVisible]: { defaultValue: true, storageKey: StorageKey.MiniMap },
    [FeatureToggle.JoysticksVisible]: { defaultValue: true, storageKey: StorageKey.Joysticks },
    [FeatureToggle.UpdateHomeView]: { defaultValue: false, storageKey: StorageKey.UpdateHomeView },
    // Opt-in: enabling it triggers the browser's local-network (loopback) permission prompt so the
    // viewer can reach the local 3Dconnexion driver. Off by default.
    [FeatureToggle.SpaceMouseEnabled]: { defaultValue: false, storageKey: StorageKey.SpaceMouse },
    // Selects @procore/bim-viewer-engine at startup; takes effect after reload.
    [FeatureToggle.ExperimentalEngineEnabled]: { defaultValue: false, storageKey: StorageKey.ExperimentalEngine },
};
